import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import HeroImageSrc from '../Image/hero-bg.jpg';
import HeroImageCover from '../Image/hero-shape.png';
import { Link } from 'react-router-dom';

const Hero = () => {
    const sliderSettings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const sliderData = [
        {
            heading: 'Your Complete Medicare Destination',
            description:
                'Get all your healthcare needs met in one place. Our clinic provides a variety of services, from regular check-ups to specialized treatments, ensuring you have easy access to comprehensive medical care.',
            buttonLabel: 'Appointment Now',
        },
        {
            heading: 'Tailored Care Just for You',
            description:
                'Experience healthcare designed around you. Our patient-focused approach means you receive individualized attention and care plans to match your unique needs, making your health journey comfortable and effective.',
            buttonLabel: 'Appointment Now',
        },
        {
            heading: 'Modern Solutions for Better Health',
            description:
                "Step into the future of healthcare with our clinic's advanced technology. From top-notch diagnostics to digital health records, we use the latest innovations to make your medical care more efficient and effective. Stay ahead in healthcare with our state-of-the-art facilities.",
            buttonLabel: 'Appointment Now',
        },
    ];

    return (
        <HeroContainer>
            <BackgroundImage src={HeroImageSrc} alt="Hero Background" />
            <HeroCover src={HeroImageCover} alt="Hero Cover" />
            <Container>
                <ContainerLeft>
                    <Slider {...sliderSettings}>
                        {sliderData.map((slide, index) => (
                            <MainHome key={index}>
                                <RightSection>
                                    <Heading>{slide.heading}</Heading>
                                    <AdditionalSection>
                                        <Paragraph>{slide.description}</Paragraph>
                                    </AdditionalSection>
                                    <AdditionalSection>
                                        <ButtonSection>
                                            <AppointmentButton>
                                                <Link to='appointments' style={{ textDecoration: 'none', color: 'inherit'}}>
                                                    {slide.buttonLabel}
                                                </Link>
                                            </AppointmentButton>
                                        </ButtonSection>
                                    </AdditionalSection>
                                </RightSection>
                            </MainHome>
                        ))}
                    </Slider>
                </ContainerLeft>
            </Container>
        </HeroContainer>
    );
};

const HeroContainer = styled.div`
  position: relative;
  margin-bottom: 150px;
  @media (max-width: 769px) {
    min-height: 600px;
    height:  auto;
    background: linear-gradient(to right, rgba(0, 114, 255, 0.8), rgba(0, 198, 255, 0.8));
  }
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80vh;
  z-index: -1;
  @media (max-width: 769px) {
    min-height: 600px;
    height:  auto;
    object-fit: cover;
  }
`;

const HeroCover = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80vh;
  z-index: 0;
  background-size:cover;
  @media (max-width: 769px) {
    display: none;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: auto;
  @media (max-width: 769px) {
    // margin: 0 0 0 5%;
  }
`;

const ContainerLeft = styled.div`
  width: 50%;
  margin-top: 10vh;
  padding-top: auto;
  // display: flex;
  // flex-direction: column;
  // align-items: flex-start;
  z-index: 100;
  // padding-left: 5%;
  @media (max-width: 769px) {
    width: 90%;
  }
`;

const MainHome = styled.div`
  display: flex;
  justify-content: center;
  max-width: 100vw;
  margin: 0 15%;
  z-index: -10px;
  @media (max-width: 769px) {
    margin: 0;
    padding: 0;
  }
`;

const RightSection = styled.div`
  width: 100%;
  max-width: 522px;
  padding-left: 5%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: auto:
`;

const Heading = styled.h1`
  color: #1e3056;
  font-size: calc(0.8vw + 35px);
  margin-bottom: 15px;
  line-height: 45px;
  font-family: 'Nunito', sans-serif;
  @media (max-width: 769px) {
    color: #fff;
  }
`;

const AdditionalSection = styled.div`
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  font-family: 'Nunito', sans-serif;
  @media (max-width: 769px) {
    color: #fff;
  }
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const AppointmentButton = styled.button`
  background: linear-gradient(to right, rgba(0, 114, 255, 0.8), rgba(0, 198, 255, 0.8));
  color: white;
  border: none;
  font-family: 'Cairo';
  display: flex:
  justify-content: center;
  align-items: center;
  width: auto;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;
  font-size: 17px;
  height: 40px;
  &:hover {
    background-color: #23465a;
  }
  @media (max-width: 769px) {
    background: white;
    color: #0075ff;
  }
`;

export default Hero;
